import { CustomComponentProps } from "utils/types/generalTypes";
import { UserPopover } from "ui";

// that's the popover component and it must be included in PostUserBlock component
export type NewUserPopoverProps = CustomComponentProps & {
    children: React.ReactNode;
};

// use this component instead of images and you can modify it as you want just keep `user-block` class in the parent div
const UserPopoverContainer = ({
    children,
    className,
    style
}: NewUserPopoverProps) => {
    return (
        <div className={`user-block ${className}`} style={style}>
            <div className="image p-relative">
                {children}
                <UserPopover />
            </div>
        </div>
    );
};

export default UserPopoverContainer;
